export const formatTimeAgo = (timestamp) => {
  if (!timestamp) return 'Hace un momento';
  
  const now = new Date();
  const date = new Date(timestamp);
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  
  if (diffSecs < 60) {
    return 'Hace un momento';
  } else if (diffMins < 60) {
    return `Hace ${diffMins} ${diffMins === 1 ? 'minuto' : 'minutos'}`;
  } else if (diffHours < 24) {
    return `Hace ${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}`;
  } else if (diffDays < 7) {
    return `Hace ${diffDays} ${diffDays === 1 ? 'día' : 'días'}`;
  } else {
    // Formatear con mes y día
    const options = { day: 'numeric', month: 'short' };
    if (date.getFullYear() !== now.getFullYear()) {
      options.year = 'numeric';
    }
    return date.toLocaleDateString(undefined, options);
  }
};

export const processTextWithLinks = (text) => {
  if (!text) return '';
  
  // Reemplazar URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  let processedText = text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  
  // Reemplazar hashtags
  const hashtagRegex = /#(\w+)/g;
  processedText = processedText.replace(hashtagRegex, '<a href="/hashtag/$1">#$1</a>');
  
  // Reemplazar menciones
  const mentionRegex = /@(\w+)/g;
  processedText = processedText.replace(mentionRegex, '<a href="/profile/$1">@$1</a>');
  
  return processedText;
};
